const validityErrorKeys = [
  'patternMismatch',
  'rangeOverflow',
  'rangeUnderflow',
  'tooLong',
  'tooShort',
  'valueMissing',
];

const errorMessageKeyMap = {
  patternMismatch: 'patternMismatch',
  rangeOverflow: 'rangeError',
  rangeUnderflow: 'rangeError',
  tooLong: 'rangeError',
  tooShort: 'rangeError',
  valueMissing: 'missingError',
};

const getErrorMessageKeyFromValidityError = (validityError) =>
  errorMessageKeyMap[validityError] ?? 'unknownError';

export default {
  props: {
    errorMessages: {
      type: Object,
      default: () => ({
        missingError: undefined,
        patternMismatch: undefined,
        rangeError: undefined,
      }),
    },
    pattern: {
      type: String,
    },
  },

  data: () => ({
    errorMessage: undefined,
    isInvalid: false,
  }),

  methods: {
    clearError() {
      this.errorMessage = undefined;
      this.isInvalid = false;
    },
    handleInvalid(event) {
      event.preventDefault();
      const formControl = event.target;
      formControl.setCustomValidity('');
      if (!formControl.validity.valid) {
        // $(this).addClass('is-invalid');
        const validityErrorKey = validityErrorKeys.find(
          (k) => formControl.validity[k]
        );
        const customErrorMessage =
          validityErrorKey &&
          this.errorMessages[
            getErrorMessageKeyFromValidityError(validityErrorKey)
          ];
        if (customErrorMessage) {
          this.errorMessage = customErrorMessage;
        }
        if (!this.errorMessage) {
          this.errorMessage = formControl.validationMessage;
        }
        this.isInvalid = true;
      }
    },
  },
};
